/**
 * DIEUKYDIEU.TV - MOBILE SEARCH MODAL & RESULTS
 */
import { t } from '../i18n.js';
import {
    POPULAR_SEARCH_TOPICS,
    FEATURED_SUGGESTIONS,
    getFeaturedSuggestions,
    getSearchHistory,
    removeSearchHistory,
    clearAllSearchHistory,
    addSearchHistory
} from './search-db.js';
import {
    removeVietnameseTones,
    escapeHtml,
    filterSearchDatabase,
    createMediaRowHTML,
    renderSearchTopicChip,
    renderFeaturedCardHTML
} from './search-utils.js';
import { renderEmptyStateHTML } from '../components/index.js';
import { renderDesktopResults } from '../search.js';

export function openMobileSearch() {
    const modal = document.getElementById('mobile-search-modal');
    const input = document.getElementById('mobile-search-input');
    if (!modal) return;

    modal.classList.add('show');
    document.body.style.overflow = 'hidden';

    if (input) {
        input.value = '';
        const clearBtn = document.getElementById('mobile-search-clear');
        if (clearBtn) clearBtn.classList.remove('show');
        setTimeout(() => input.focus(), 250);
    }

    renderMobileEmptyState();
}

export function closeMobileSearch() {
    const modal = document.getElementById('mobile-search-modal');
    const input = document.getElementById('mobile-search-input');
    if (modal) modal.classList.remove('show');
    document.body.style.overflow = '';
    if (input) input.blur();
}

export function clearMobileSearch() {
    const input = document.getElementById('mobile-search-input');
    const clearBtn = document.getElementById('mobile-search-clear');
    if (input) {
        input.value = '';
        input.focus();
    }
    if (clearBtn) clearBtn.classList.remove('show');
    renderMobileEmptyState();
}

export function fillMobileSearch(keyword) {
    applySearchQuery(keyword, true);
}

export function handleMobileSearch(val) {
    const clearBtn = document.getElementById('mobile-search-clear');
    const container = document.getElementById('mobile-search-body');

    if (val.trim().length > 0) {
        if (clearBtn) clearBtn.classList.add('show');
        if (container) renderMobileResults(val.trim(), container);
    } else {
        if (clearBtn) clearBtn.classList.remove('show');
        renderMobileEmptyState();
    }
}

export function renderMobileEmptyState() {
    const container = document.getElementById('mobile-search-body');
    if (!container) return;

    const history = getSearchHistory();
    let historySection = '';

    if (history.length > 0) {
        const historyItems = history.slice(0, 5).map(term => `
            <div class="search-history-item" data-query="${escapeHtml(term)}" data-mobile="true" onclick="applySearchQuery(this)">
                <div class="search-history-left">
                    <span class="material-symbols-rounded">history</span>
                    <span class="search-history-text">${escapeHtml(term)}</span>
                </div>
                <button class="search-history-del-btn" data-term="${escapeHtml(term)}" onclick="removeSearchHistory(this, event)" aria-label="Xóa">
                    <span class="material-symbols-rounded">close</span>
                </button>
            </div>
        `).join('');

        historySection = `
            <div class="search-section-block">
                <div class="search-section-header">
                    <div class="search-section-title">
                        <span class="material-symbols-rounded">history</span>
                        <span>${t('search_history')}</span>
                    </div>
                    <button class="search-clear-all-btn" onclick="clearAllSearchHistory(event)">${t('search_clear_all')}</button>
                </div>
                <div class="search-history-list">
                    ${historyItems}
                </div>
            </div>
        `;
    }

    const topicChips = POPULAR_SEARCH_TOPICS.map(tp => renderSearchTopicChip(tp, true)).join('');
    const featuredItems = getFeaturedSuggestions();
    const featuredCards = featuredItems.map(item => renderFeaturedCardHTML(item, true)).join('');

    container.innerHTML = `
        ${historySection}
        <div class="search-section-block">
            <div class="search-section-header">
                <div class="search-section-title">
                    <span class="material-symbols-rounded">trending_up</span>
                    <span>${t('search_trending_title')}</span>
                </div>
            </div>
            <div class="search-chips-wrap">
                ${topicChips}
            </div>
        </div>
        <div class="search-section-block">
            <div class="search-section-header">
                <div class="search-section-title">
                    <span class="material-symbols-rounded">auto_awesome</span>
                    <span>${t('search_featured')}</span>
                </div>
            </div>
            <div class="ms-featured-list">
                ${featuredCards}
            </div>
        </div>
    `;
}

export function renderMobileResults(query, containerEl, showAll = true, filterType = 'all') {
    const allMatches = filterSearchDatabase(query, 'all');
    const totalCount = allMatches.length;
    const matches = filterType === 'all' ? allMatches : allMatches.filter(item => item.type === filterType);

    if (matches.length === 0) {
        const topicChips = POPULAR_SEARCH_TOPICS.slice(0, 4).map(tp => renderSearchTopicChip(tp, true)).join('');

        containerEl.innerHTML = `
            <div class="search-empty-results">
                ${renderEmptyStateHTML({
                    icon: 'search_off',
                    title: t('search_no_results') || 'Không tìm thấy kết quả phù hợp',
                    desc: 'Thử khám phá các chủ đề phổ biến:'
                })}
                <div class="search-chips-wrap">
                    ${topicChips}
                </div>
            </div>
        `;
        return;
    }

    const counts = { all: totalCount, video: 0, audio: 0, article: 0 };
    for (let i = 0; i < allMatches.length; i++) {
        const tType = allMatches[i].type;
        if (counts[tType] !== undefined) counts[tType]++;
    }

    const filterTabsHtml = `
        <div class="search-filter-tabs">
            <button class="search-filter-tab ${filterType === 'all' ? 'active' : ''}"
                    onclick="renderMobileResults(document.getElementById('mobile-search-input')?.value || '', document.getElementById('mobile-search-body'), true, 'all')">
                ${t('search_filter_all')} (${counts.all})
            </button>
            ${counts.video > 0 ? `
            <button class="search-filter-tab ${filterType === 'video' ? 'active' : ''}"
                    onclick="renderMobileResults(document.getElementById('mobile-search-input')?.value || '', document.getElementById('mobile-search-body'), true, 'video')">
                ${t('search_filter_video')} (${counts.video})
            </button>` : ''}
            ${counts.audio > 0 ? `
            <button class="search-filter-tab ${filterType === 'audio' ? 'active' : ''}"
                    onclick="renderMobileResults(document.getElementById('mobile-search-input')?.value || '', document.getElementById('mobile-search-body'), true, 'audio')">
                ${t('search_filter_audio')} (${counts.audio})
            </button>` : ''}
            ${counts.article > 0 ? `
            <button class="search-filter-tab ${filterType === 'article' ? 'active' : ''}"
                    onclick="renderMobileResults(document.getElementById('mobile-search-input')?.value || '', document.getElementById('mobile-search-body'), true, 'article')">
                ${t('search_filter_articles')} (${counts.article})
            </button>` : ''}
        </div>
    `;

    const rowsHtml = matches.map(item => createMediaRowHTML(item, query, true)).join('');

    containerEl.innerHTML = `
        <div class="mobile-search-results-wrap">
            ${filterTabsHtml}
            <div class="media-row-list">
                ${rowsHtml}
            </div>
        </div>
    `;
}

export function renderQuickSearchResults(query, containerEl, isMobile = false) {
    if (isMobile) {
        renderMobileResults(query, containerEl);
    } else {
        renderDesktopResults(query, containerEl);
    }
}

